import { useSelector } from "react-redux";
import BudgetNormalizationDebugger from "pages/Calculation/Debugger/BudgetNormalization";
import AbsenceDaysReductionFactor from "pages/Calculation/Debugger/AbsenceDaysReductionFactor";
import MissingMonthsReductionFactor from "pages/Calculation/Debugger/MissingMonthsReductionFactor";
import { useForm } from "react-hook-form";
import { api } from "helpers/axios";
import { useState } from "react";
import CalculationExclusion from "./Debugger/CalculationExclusion";
import { useTranslation } from "translation/useTranslation";

export default function CalculationDebugging() {
  const { editableTranslate } = useTranslation();

  const { register, watch, handleSubmit, formState: { errors } } = useForm();

  const [debugResults, setDebugResults] = useState({});

  const handleBudgetNormalizationSubmit = (data) => {
    const parameters = [
      'budget_amount',
      'total_fixed_amount',
      'payout_distribution',
      'floor_amount',
      'floor_type',
    ];

    const filteredData = filterDataBasedOnParameters(data, parameters);
    filteredData.debugger = 'budget_normalization';

    callApi(filteredData).then(response => {
      setDebugResults({
        result: response.normalized_budget,
        debugs: response.debugs,
      });
    });
  }

  const handleAbsenceDaysReductionFactorSubmit = (data) => {
    const parameters = [
      'employee_working_days_per_week',
      'employee_absence_days',
      'budget_working_days',
      'prorate_enabled',
      'prorate_day_threshold_type',
      'prorate_day_threshold'
    ];

    const filteredData = filterDataBasedOnParameters(data, parameters);
    filteredData.debugger = 'absence_days_reduction_factor';

    callApi(filteredData).then(response => {
      setDebugResults({
        result: response.reduction_factor,
        debugs: response.debugs,
      });
    });
  }

  const handleMissingMonthsReductionFactorSubmit = (data) => {
    const parameters = [
      'employee_missing_months',
      'budget_number_of_total_months',
    ];

    const filteredData = filterDataBasedOnParameters(data, parameters);
    filteredData.debugger = 'missing_months_reduction_factor';

    callApi(filteredData).then(response => {
      setDebugResults({
        result: response.reduction_factor,
        debugs: response.debugs,
      });
    });
  }

  const handleCalculationExclusionSubmit = (data) => {
    const parameters = [
      'employee_balanced_scorecard_result',
      'minimum_performance_result',
      'employee_missing_months',
      'employee_missing_months_exclusion_enabled',
      'employee_missing_months_exclusion_month_threshold',
      'employee_manually_excluded',
      'employee_employment_start_date',
      'employee_employment_exit_date',
      'employee_minimum_employment_months',
      'employee_working_days_per_week',
      'employee_absence_days',
      'budget_working_days',
      'employee_minimum_days_exclusion_enabled',
      'exclusion_day_threshold',
      'exclusion_day_threshold_type'
    ];

    const filteredData = filterDataBasedOnParameters(data, parameters);
    filteredData.debugger = 'calculation_exclusion';

    callApi(filteredData).then(response => {
      setDebugResults({
        result: {
          excluded: response.excluded,
          reason: response.reason,
        },
        debugs: response.debugs,
      });
    });
  }

  const callApi = async (body) => {
    const { status, data } = await api.post('/calculation-engine/helper-debug', body);

    if (status === 200) {
      return data.result;
    } else {
      return null;
    }
  }

  const filterDataBasedOnParameters = (data, parameters) => {
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([key]) => parameters.includes(key))
    );

    return filteredData;
  }

  const debuggers = [
    {
      name: 'Budget Normalization',
      translation_key: 'global.menu.calculation.debugger.budget_normalization',
      id: 'budget_normalization',
      component: <BudgetNormalizationDebugger register={register} watch={watch} handleSubmit={handleSubmit} onSubmit={handleBudgetNormalizationSubmit} />
    },
    {
      name: 'Absence Days Reduction Factor',
      translation_key: 'global.menu.calculation.debugger.absence_days_reduction_factor',
      id: 'absence_days_reduction_factor',
      component: <AbsenceDaysReductionFactor register={register} watch={watch} handleSubmit={handleSubmit} onSubmit={handleAbsenceDaysReductionFactorSubmit} />
    },
    {
      name: 'Missing Months Reduction Factor',
      translation_key: 'global.menu.calculation.debugger.missing_months_reduction_factor',
      id: 'missing_months_reduction_factor',
      component: <MissingMonthsReductionFactor register={register} handleSubmit={handleSubmit} onSubmit={handleMissingMonthsReductionFactorSubmit} />
    },
    {
      name: 'Calculation Exclusion',
      translation_key: 'global.menu.calculation.debugger.calculation_exclusion',
      id: 'calculation_exclusion',
      component: <CalculationExclusion register={register} watch={watch} handleSubmit={handleSubmit} onSubmit={handleCalculationExclusionSubmit} />
    }
  ];

  return (
    <>
      <div className="col-lg col-md-12 d-flex">
        <div className={`bg-white w-100 p-4 content-card`}>
          <h4>{editableTranslate('global.menu.calculation.calculation_debugging')}</h4>

          <div className="row mt-4">
            <div className="col-md-7">
              <ul className="nav nav-pills mb-3" role="tablist" data-testid="debugger-tabs">
                {
                  debuggers.map((d, index) => {
                    return (
                      <li className="nav-item" key={index}>
                        <a className={`nav-link ${index === 0 ? 'active' : ''}`} id={`${d.id}-tab`} data-toggle="tab" href={`#${d.id}`} role="tab" aria-controls={`${d.id}`} aria-selected="true" data-testid={`debugger-tab-${d.id}`}>{editableTranslate(d.translation_key, d.name)}</a>
                      </li>
                    );
                  })
                }
              </ul>
              <div className="tab-content">
                {
                  debuggers.map((d, index) => {
                    return (
                      <div className={`tab-pane fade ${index === 0 ? 'show active' : ''}`} id={d.id} role="tabpanel" aria-labelledby={`${d.id}-tab`} key={index} data-testid={`debugger-pane-${d.id}`}>
                        {d.component}
                      </div>
                    );
                  })
                }
              </div>
            </div>
            <div className="col-md-5">
              <h3>Debug Results</h3>
              <pre>{JSON.stringify(debugResults, null, 2)}</pre>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
